module.exports = __webpack_public_path__ + "img/1.96b2ab3b.png";